import { useEffect, useState } from "react";
import client, { apiError } from "../../api/client";
import { toast } from "sonner";
import { Plus, Trash2, X, Loader2 } from "lucide-react";

const inputCls = "w-full h-9 px-3 rounded-md border border-input bg-background text-sm outline-none focus:ring-2 focus:ring-ring/20";
const EMPTY = { name: "", ico: "", dic: "", street: "", city: "", zip: "", email: "", note: "", vyfakturuj_login: "", vyfakturuj_api_key: "" };
const FIELDS = [
  ["name", "Název"], ["ico", "IČO"], ["dic", "DIČ"], ["street", "Ulice"],
  ["city", "Město"], ["zip", "PSČ"], ["email", "E-mail (odesílatel)"], ["note", "Poznámka"],
  ["vyfakturuj_login", "vyfakturuj.cz login"], ["vyfakturuj_api_key", "vyfakturuj.cz API klíč"],
];

export default function CompaniesManager() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const load = () => client.get("/admin/companies").then((res) => setItems(res.data));
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name.trim()) return toast.error("Vyplňte název");
    setSaving(true);
    try {
      if (modal === "new") await client.post("/admin/companies", form);
      else await client.put(`/admin/companies/${form.id}`, form);
      toast.success("Uloženo"); setModal(null); load();
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };

  const del = async (c) => {
    if (!window.confirm(`Smazat společnost ${c.name}?`)) return;
    try { await client.delete(`/admin/companies/${c.id}`); load(); } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-lg font-medium">Fakturační společnosti</h2>
        <button onClick={() => { setForm(EMPTY); setModal("new"); }} data-testid="add-company-btn" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 flex items-center gap-1"><Plus className="h-4 w-4" /> Nová společnost</button>
      </div>
      <div className="border border-border rounded-lg divide-y divide-border">
        {items.map((c) => (
          <div key={c.id} className="flex items-center gap-3 px-4 py-3" data-testid={`company-row-${c.id}`}>
            <div className="flex-1">
              <div className="text-sm font-medium">{c.name}</div>
              <div className="text-xs text-muted-foreground">{[c.ico && `IČO ${c.ico}`, c.email, c.vyfakturuj_login ? "vyfakturuj ✓" : "vyfakturuj —"].filter(Boolean).join(" · ")}{c.note && ` · ${c.note}`}</div>
            </div>
            <button onClick={() => { setForm({ ...EMPTY, ...c }); setModal("edit"); }} className="text-xs text-muted-foreground hover:text-foreground px-2">Upravit</button>
            <button onClick={() => del(c)} className="p-1.5 text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Žádné společnosti</div>}
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onMouseDown={() => setModal(null)}>
          <div className="bg-background rounded-lg border border-border shadow-lg w-full max-w-lg max-h-[90vh] overflow-auto" onMouseDown={(e) => e.stopPropagation()} data-testid="company-modal">
            <div className="flex items-center justify-between px-5 h-14 border-b border-border sticky top-0 bg-background">
              <h3 className="font-heading font-semibold">{modal === "new" ? "Nová společnost" : "Upravit společnost"}</h3>
              <button onClick={() => setModal(null)}><X className="h-5 w-5 text-muted-foreground" /></button>
            </div>
            <div className="p-5 grid grid-cols-2 gap-3">
              {FIELDS.map(([k, label]) => (
                <div key={k} className={["name", "note", "vyfakturuj_api_key"].includes(k) ? "col-span-2" : ""}>
                  <label className="text-xs text-muted-foreground">{label}</label>
                  <input value={form[k] || ""} onChange={(e) => set(k, e.target.value)} className={inputCls} data-testid={`company-${k}`} />
                </div>
              ))}
            </div>
            <div className="px-5 py-4 border-t border-border flex justify-end gap-2 sticky bottom-0 bg-background">
              <button onClick={() => setModal(null)} className="h-9 px-4 rounded-md border border-border text-sm hover:bg-secondary">Zrušit</button>
              <button onClick={save} disabled={saving} data-testid="company-save" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 disabled:opacity-60 flex items-center gap-2">{saving && <Loader2 className="h-4 w-4 animate-spin" />} Uložit</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
